var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "PrintOrSaveInvoicesStepComponent",
    {
      attrs: {
        stepNumber: _vm.stepNumber,
        title: _vm.texts.title,
        explanation: _vm.texts.explanation,
      },
    },
    [
      _c("TemplateSelectorTreeComponent", {
        staticClass: "invoices-template-selector-container",
        attrs: { idEntityType: _vm.idEntityType },
        on: {
          templateSelected: _vm.templateSelected,
          closeDialog: _vm.onCloseDialog,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }